import React, {useEffect, useState} from 'react'
import InformationUserContainer from "../../InformationUserContainer"
import {Checkbox, message, Popconfirm} from 'antd';
import parseToken from "../../../../helpers/parseToken";
import {getUserProfileV1, updateUserProfileV1} from "../../../../services/api/apiSwagger";

function FollowMeContainer() {
    const [followMe, setFollowMe] = useState(false)
    const info = parseToken()

    const onChange = (e) => {
        setFollowMe({
            ...followMe,
            isFollowMe: e.target.checked ? 1 : 0
        })
    }

    const _getUserFollowMe = async () => {
        try {
            const response = await getUserProfileV1(info.sub, {})

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setFollowMe(data[0] || {})
        } catch (e) {
            message.error(e.message)
        }
    }

    const _updateUserFollowMe = async () => {
        try {
            const response = await updateUserProfileV1(info.sub, followMe)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            message.success('Cập nhật Follow me thành công!')
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _getUserFollowMe()
        // eslint-disable-next-line
    }, [])

    return (
        <div className="InformationContainer PageDefault">
            <InformationUserContainer isActive="followMe">
                <div className="HasDescription">
                    <h1 className="PageTitle">Follow Me</h1>
                    <p className="Description">Khi lựa chọn thiết lập này, sau khi bạn logout khỏi ứng dụng web Alohub,
                        bạn vẫn có thể tiếp nhận cuộc gọi đến nếu cài đặt softphone trên thiết bị di động.</p>
                    <div className="d-flex align-items-center PageHeading justify-content-start">
                        <div className="mr-3"><Checkbox checked={followMe.isFollowMe || false} onChange={onChange}>Chọn
                            follow me</Checkbox></div>

                        <Popconfirm placement="bottom" title="Bạn có chắc chắn muốn cập nhật Follow me?"
                                    onConfirm={_updateUserFollowMe} okText="Có" cancelText="Không">
                            <button className="ButtonCustom">Save</button>
                        </Popconfirm>
                    </div>
                </div>
            </InformationUserContainer>
        </div>
    )
}

export default FollowMeContainer
